/** Testi delle aree relatore e regia e della navigazione di gestione. */
export const navGestione = {
  admin: [
    { to: '/admin', testo: 'Percorsi' },
    { to: '/admin/webinar', testo: 'Webinar' },
    { to: '/admin/utenti', testo: 'Utenti' },
    { to: '/admin/impostazioni', testo: 'Impostazioni' },
    { to: '/sicurezza', testo: 'Sicurezza' },
  ],
  relatore: [
    { to: '/relatore', testo: 'I miei webinar' },
    { to: '/sicurezza', testo: 'Sicurezza' },
  ],
  regia: [
    { to: '/regia', testo: 'Webinar' },
    { to: '/sicurezza', testo: 'Sicurezza' },
  ],
  ruolo: { admin: 'Amministrazione', relatore: 'Area relatore', regia: 'Regia' } as const,
};

export const nonAutorizzata = {
  titolo: 'Area riservata',
  admin: 'Questa area è riservata agli amministratori.',
  relatore: 'Questa area è riservata ai relatori.',
  regia: 'Questa area è riservata alla regia.',
  partecipante: 'Questa area è riservata ai partecipanti.',
  azione: 'Vai alla tua pagina',
};

export const relatore = {
  titolo: 'I miei webinar',
  sottotitolo: 'I numeri si aggiornano man mano che i partecipanti confermano. Non vedi i nomi: li gestisce l’organizzatore.',
  nessunoTitolo: 'Nessun webinar assegnato',
  nessunoTesto: 'Quando l’organizzatore ti assegna a un webinar, compare qui.',
  confermatiOnline: (n: number) => `${n} online`,
  confermatiSala: (n: number) => `${n} in sala`,
  invitati: (n: number) => `${n} da confermare`,
  rinunciati: (n: number) => `${n} rinunce`,
  modalitaRegia: 'Il flusso arriva dalla regia della sala.',
  modalitaRelatore: 'Trasmetterai dal tuo computer: apri la console per provare camera e microfono.',
  apriConsole: 'Apri la console',
  stati: { bozza: 'Bozza', pubblicato: 'Pubblicato', in_diretta: 'In diretta', test_aperto: 'Test aperto', chiuso: 'Concluso' } as const,
};

export const regia = {
  titolo: 'Webinar',
  sottitolo: 'Per ogni webinar trovi la modalità di ingresso e la chiave del flusso. Gli indirizzi SRT e RTMP dei nodi sono nella pagina del webinar.',
  apri: 'Apri la regia',
  nessunoTitolo: 'Nessun webinar pubblicato',
  nessunoTesto: 'Quando l’organizzatore pubblica un webinar, compare qui con la chiave del flusso.',
  chiave: 'Chiave del flusso',
  copia: 'Copia',
  copiata: 'Chiave copiata.',
  modalitaRegia: 'Ingresso dalla regia (SRT, RTMP di riserva)',
  modalitaRelatore: 'Il relatore trasmette dal proprio computer: la regia non invia il flusso.',
};
